export const LOGIN_CALLBACK_ROUTE = "/auth0/login-callback";
export const LOGOUT_CALLBACK_ROUTE = "/auth0/logout-callback";
export const PROXY_LOGOUT_CALLBACK_ROUTE = "/auth0/proxy-logout-callback";

export const IS_AUTH0_ENABLED = process.env.NEXT_PUBLIC_AUTH_PROVIDER !== "fusion";
